export default __webpack_public_path__ + "static/media/LineForHome.1d44632c.svg";